export default "__VITE_ASSET__GpvMDArZ__"